import { MetricDetail } from '@fullstory/proto/fs/services/dx-objects';
import { MetricRecord } from '@fullstory/proto/fs/services/search-settings';
import { getObjectWithOverlayStorageId, useAllSavedMetrics } from '@fullstory/redux';
import { useMemo } from 'react';
import { getSavedMetricVisualizationSettings } from '../utils';

type MetricSettings = ReturnType<typeof getSavedMetricVisualizationSettings>;

export const useMetricOverlay = (
  metricId: string,
  overlayHash?: string,
): {
  metricRecord: MetricRecord | null;
  metricSettings: MetricSettings;
  metricDetail: MetricDetail | null;
} => {
  const { byId: metricsById } = useAllSavedMetrics(true);
  const metricStorageId = overlayHash
    ? getObjectWithOverlayStorageId(metricId, overlayHash)
    : metricId;
  const savedMetricDetail = useMemo(
    () => (metricStorageId ? metricsById?.[metricStorageId] ?? null : null),
    [metricStorageId, metricsById],
  );
  const savedMetricRecord = savedMetricDetail?.metric ?? null;
  const savedMetricSettings = getSavedMetricVisualizationSettings(savedMetricRecord);

  return {
    metricRecord: savedMetricRecord,
    metricSettings: savedMetricSettings,
    metricDetail: savedMetricDetail,
  };
};
